var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttention(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z",
    fill: "#E50B20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.61 40.0657L34.3389 16.3238C33.8409 15.4948 32.9665 15 31.9996 15C31.0327 15 30.1583 15.4948 29.6619 16.3221L15.3892 40.0657C14.883 40.9076 14.87 41.9605 15.3535 42.8154C15.8353 43.6704 16.7454 44.2008 17.7285 44.2008H46.2723C47.2538 44.2008 48.1655 43.6704 48.6473 42.8154C49.1307 41.9605 49.1161 40.9076 48.61 40.0657ZM32.8107 39.334H31.1884C30.7407 39.334 30.3773 38.9707 30.3773 38.5229V36.9006C30.3773 36.4529 30.7407 36.0895 31.1884 36.0895H32.8107C33.2585 36.0895 33.6218 36.4529 33.6218 36.9006V38.5229C33.6218 38.9707 33.2585 39.334 32.8107 39.334ZM31.9996 32.845C31.1041 32.845 30.3773 32.1182 30.3773 31.2227V26.3559C30.3773 25.4604 31.1041 24.7336 31.9996 24.7336C32.8951 24.7336 33.6218 25.4604 33.6218 26.3559V31.2227C33.6218 32.1182 32.8951 32.845 31.9996 32.845Z",
    fill: "#E50B20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttention);
export default __webpack_public_path__ + "static/media/attention.6f2c2bea35010520adce59d9a5e10554.svg";
export { ForwardRef as ReactComponent };